export const getArrOfUniqueObj = <TInfo extends Record<any, any>>(
  arr: TInfo[],
  field: keyof TInfo,
) => {
  const uniqueFields = new Set(arr.map((item) => item[field]));

  return arr.filter((item) => uniqueFields.delete(item[field]));
};
